angular.module("digitalLeasing.module").component("downloadInfoBanca", {
    templateUrl: "ng/components/digitalLeasing/goodManagement/downloadInfoBanca/downloadInfoBanca.view.html",
    bindings: {
        model: "=",
        showHideComponent: '&'
    },
    controllerAs: "downloadInfoBancaCtrl",
    controller: DownloadInfoBancaController
});

function DownloadInfoBancaController(
    $simulationService,
    $download,
    $rootScope
) {
    var self = this;

    self.$onInit = function () {
        self.$rootScope = $rootScope;
        getPopulation();
    }

    var getPopulation = function () {
        self.showLoader = true;
        $simulationService
            .populateDownloadCheckList(self.model)
            .then(function (response) {
                self.listFileDownload = response.documents;

                self.visualComponent = self.listFileDownload.some(function (element) {
                    return element.cdDoc == "P20"
                })

                self.showHideComponent({
                    value: !self.visualComponent
                })
                self.showLoader = false;

            })
            .catch(function (error) {
                console.log("Error", error);
                self.showLoader = false;
            });

    }

    self.generdownloadDoc = function (file) {
        file.downloaded = true;
        var input = {
            downloadKey: file.downloadKey
        }
        var url = "/uni/downloadDocDigital/service-infos/"
        $download.getGenericDownload(url, input)
            .then(function (response) {
                console.log(response)
            })
    };
}